module.exports = __webpack_public_path__ + "img/it-declaration-locked.3cde4da2.webp";